import { Box, Checkbox, FormLabel, Grid } from "@mui/material";
import Field from "components/Field";
import { SkuDeliveryMethodSettingProps } from "../SkuDeliveryMethodSetting";

interface BooleanSettingProps {
  item: SkuDeliveryMethodSettingProps;
}

const BooleanSetting = ({ item }: BooleanSettingProps) => {
  const initialValue =
    item.value === undefined || String(item.value).toLowerCase() === "true";

  return (
    <Field
      name={`settingValues[${item.fieldIndex}].value`}
      type="checkbox"
      initialValue={initialValue}
    >
      {({ input }) => (
        <Grid item xs={6}>
          <Box>
            <FormLabel>{item.name}</FormLabel>
            <Checkbox {...input} />
          </Box>
        </Grid>
      )}
    </Field>
  );
};

export default BooleanSetting;
